import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["SubmitBatch"] */ "/app/src/app/(training)/task/[name]/submit/batch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubmitOutputOnly"] */ "/app/src/app/(training)/task/[name]/submit/output-only.tsx");
